import * as api from '../api/economicunits';

import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const ECONOMIC_UNIT_ADD_PROPERTY_VALUATION = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_ADD_PROPERTY_VALUATION',
);

export const ECONOMIC_UNIT_SET_PROPERTY_VALUATION = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_SET_PROPERTY_VALUATION',
);

export const ECONOMIC_UNITS_SEARCH = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNITS_SEARCH',
);

export const ECONOMIC_UNIT_FETCH = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_FETCH',
);

export const ECONOMIC_UNITS_SEARCH_CONFIG = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNITS_SEARCH_CONFIG',
);

export const ECONOMIC_UNITS_CREATE = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNITS_CREATE',
);

export const ECONOMIC_UNITS_UPDATE = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNITS_UPDATE',
);

export const ECONOMIC_UNITS_UPDATE_DATA_INPUTS = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNITS_UPDATE_DATA_INPUTS',
);

export const ECONOMIC_UNIT_PROPERTY_INSERT = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_PROPERTY_INSERT',
);

export const ECONOMIC_UNIT_PROPERTY_FETCH = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_PROPERTY_FETCH',
);

export const ECONOMIC_UNIT_PROPERTY_DELETE = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_PROPERTY_DELETE',
);

export const ECONOMIC_UNIT_PROPERTY_USE_INSERT = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_PROPERTY_USE_INSERT',
);

export const ECONOMIC_UNIT_PROPERTY_USES_FETCH = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_PROPERTY_USES_FETCH',
);

export const ECONOMIC_UNIT_PROPERTY_USE_UPDATE = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_PROPERTY_USE_UPDATE',
);

export const ECONOMIC_UNIT_PROPERTY_USE_DELETE = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_PROPERTY_USE_DELETE',
);

export const ECONOMIC_UNIT_PROPERTY_USE_REFRESH_IMPROVEMENT = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_PROPERTY_USE_REFRESH_IMPROVEMENT',
);

export const ECONOMIC_UNIT_REFRESH_LAND = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_REFRESH_LAND',
);

export const ECONOMIC_UNIT_RENT_ROLLS_FETCH = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_RENT_ROLLS_FETCH',
);

export const ECONOMIC_UNIT_INCOME_VALUATIONS_FETCH = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_INCOME_VALUATIONS_FETCH',
);

export const VALID_APPROACHES_FETCH = createRequestTypes(
  'APPRAISAL/VALID_APPROACHES_FETCH',
);

export const ECONOMIC_UNIT_INCOME_VALUATION_CREATE = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_INCOME_VALUATION_CREATE',
);

export const INCOME_DIRECT_CAP_FETCH = createRequestTypes(
  'APPRAISAL/INCOME_DIRECT_CAP_FETCH',
);

export const INCOME_DIRECT_CAP_UPDATE = createRequestTypes(
  'APPRAISAL/INCOME_DIRECT_CAP_UPDATE',
);

export const INCOME_DIRECT_CAP_ACTUALS_FETCH = createRequestTypes(
  'APPRAISAL/INCOME_DIRECT_CAP_ACTUALS_FETCH',
);

export const INCOME_DIRECT_CAP_ACTUALS_UPDATE = createRequestTypes(
  'APPRAISAL/INCOME_DIRECT_CAP_ACTUALS_UPDATE',
);

export const INCOME_DIRECT_ACTUALS_PROPERTY_USES_FETCH = createRequestTypes(
  'APPRAISAL/INCOME_DIRECT_ACTUALS_PROPERTY_USES_FETCH',
);

export const INCOME_DIRECT_ACTUALS_EXPENSES_FETCH = createRequestTypes(
  'APPRAISAL/INCOME_DIRECT_ACTUALS_EXPENSES_FETCH',
);

export const INCOME_DIRECT_ACTUALS_ADDL_INCOME_FETCH = createRequestTypes(
  'APPRAISAL/INCOME_DIRECT_ACTUALS_ADDL_INCOME_FETCH',
);

export const INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI_FETCH = createRequestTypes(
  'APPRAISAL/INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI_FETCH',
);

export const FETCH_CODE_FILE = createRequestTypes('APPRAISAL/FETCH_CODE_FILE');

export const FETCH_INCOME_CALCULATION_RULE = createRequestTypes(
  'APPRAISAL/FETCH_INCOME_CALCULATION_RULE',
);

export const FETCH_EXPENSE_CALCULATION_RULE = createRequestTypes(
  'APPRAISAL/FETCH_EXPENSE_CALCULATION_RULE',
);

export const FETCH_LEASING_CONCESSIONS_CALCULATION_RULE = createRequestTypes(
  'APPRAISAL/FETCH_LEASING_CONCESSIONS_CALCULATION_RULE',
);

export const FETCH_REIMBURSED_EXPENSE_CALCULATION_RULE = createRequestTypes(
  'APPRAISAL/FETCH_REIMBURSED_EXPENSE_CALCULATION_RULE',
);

export const FETCH_INCOME_RATE_TYPES = createRequestTypes(
  'APPRAISAL/FETCH_INCOME_RATE_TYPES',
);

export const INSERT_INCOME_DIRECT_ACTUALS_PROPERTY_USE = createRequestTypes(
  'APPRAISAL/INSERT_INCOME_DIRECT_ACTUALS_PROPERTY_USE',
);
export const INSERT_INCOME_DIRECT_ACTUALS_EXPENSE = createRequestTypes(
  'APPRAISAL/INSERT_INCOME_DIRECT_ACTUALS_EXPENSE',
);
export const INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME = createRequestTypes(
  'APPRAISAL/INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME',
);
export const DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME = createRequestTypes(
  'APPRAISAL/DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME',
);
export const INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI = createRequestTypes(
  'APPRAISAL/INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI',
);
export const DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI = createRequestTypes(
  'APPRAISAL/DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI',
);
export const DELETE_INCOME_DIRECT_ACTUALS_EXPENSE = createRequestTypes(
  'APPRAISAL/DELETE_INCOME_DIRECT_ACTUALS_EXPENSE',
);

export const UPDATE_INCOME_DIRECT_ACTUALS_EXPENSE = createRequestTypes(
  'APPRAISAL/UPDATE_INCOME_DIRECT_ACTUALS_EXPENSE',
);

export const UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME = createRequestTypes(
  'APPRAISAL/UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME',
);

export const UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI = createRequestTypes(
  'APPRAISAL/UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI',
);
export const DELETE_INCOME_DIRECT_ACTUALS_PROPERTY_USE = createRequestTypes(
  'APPRAISAL/DELETE_INCOME_DIRECT_ACTUALS_PROPERTY_USE',
);

export const UPDATE_INCOME_DIRECT_ACTUALS_PROPERTY_USE = createRequestTypes(
  'APPRAISAL/UPDATE_INCOME_DIRECT_ACTUALS_PROPERTY_USE',
);

export const RECALCULATE_DIRECT_CAP_ACTUALS = createRequestTypes(
  'APPRAISAL/RECALCULATE_DIRECT_CAP_ACTUALS',
);

export const ECONOMIC_UNIT_RECALCULATE = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNIT_RECALCULATE',
);

export const DELETE_DIRECT_CAP_ACTUALS = createRequestTypes(
  'APPRAISAL/DELETE_DIRECT_CAP_ACTUALS',
);

export const DELETE_DIRECT_CAP_MODEL = createRequestTypes(
  'APPRAISAL/DELETE_DIRECT_CAP_MODEL',
);

export const FETCH_ECONOMIC_UNIT_PROPERTY_VALUATIONS = createRequestTypes(
  'APPRAISAL/FETCH_ECONOMIC_UNIT_PROPERTY_VALUATIONS',
);

export const INCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION = createRequestTypes(
  'APPRAISAL/INCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION',
);

export const EXCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION = createRequestTypes(
  'APPRAISAL/EXCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION',
);

export const FETCH_ECONOMIC_UNIT_RECONCILE = createRequestTypes(
  'APPRAISAL/FETCH_ECONOMIC_UNIT_RECONCILE',
);

export const UPDATE_ECONOMIC_UNIT_RECONCILE = createRequestTypes(
  'APPRAISAL/UPDATE_ECONOMIC_UNIT_RECONCILE',
);

export const FETCH_ECONOMIC_UNIT_ALLOCATE = createRequestTypes(
  'APPRAISAL/FETCH_ECONOMIC_UNIT_ALLOCATE',
);

export const UPDATE_ECONOMIC_UNIT_ALLOCATE = createRequestTypes(
  'APPRAISAL/UPDATE_ECONOMIC_UNIT_ALLOCATE',
);

export const FETCH_ECONOMIC_UNIT_DISTRIBUTION = createRequestTypes(
  'APPRAISAL/FETCH_ECONOMIC_UNIT_DISTRIBUTION',
);

export const UPDATE_ECONOMIC_UNIT_DISTRIBUTION = createRequestTypes(
  'APPRAISAL/UPDATE_ECONOMIC_UNIT_DISTRIBUTION',
);

export const UPDATE_INCOME_DIRECT_ACTUALS_NAME = createRequestTypes(
  'APPRAISAL/UPDATE_INCOME_DIRECT_ACTUALS_NAME',
);

export const UPDATE_MARKET_AREA_TAX_RATE = createRequestTypes(
  'APPRAISAL/UPDATE_MARKET_AREA_TAX_RATE',
);

export const UPDATE_MARKET_AREA_TAX_RATE_LOAD = createRequestTypes(
  'APPRAISAL/UPDATE_MARKET_AREA_TAX_RATE_LOAD',
);

export const FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLLS = createRequestTypes(
  'APPRAISAL/FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLLS',
);

export const CREATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL = createRequestTypes(
  'APPRAISAL/CREATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL',
);

export const UPDATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL = createRequestTypes(
  'APPRAISAL/UPDATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL',
);

export const DELETE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL = createRequestTypes(
  'APPRAISAL/DELETE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL',
);

export const DELETE_ECONOMIC_UNIT = createRequestTypes(
  'APPRAISAL/DELETE_ECONOMIC_UNIT',
);

export const FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLL_SUMMARY = createRequestTypes(
  'APPRAISAL/FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLL_SUMMARY',
);

export const UPDATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL_SUMMARY = createRequestTypes(
  'APPRAISAL/UPDATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL_SUMMARY',
);

export const CALCULATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL = createRequestTypes(
  'APPRAISAL/CALCULATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL',
);

export const ECONOMIC_SEARCH_STANDALONE = createRequestTypes(
  'APPRAISAL/ECONOMIC_SEARCH_STANDALONE',
);

export const ECON_UNIT_CODES_FETCH_START = 'APPRAISAL/ECON_UNIT_CODES_FETCH_START';
export const ECON_UNIT_CODES_FETCH_SUCCESS = 'APPRAISAL/ECON_UNIT_CODES_FETCH_SUCCESS';
export const ECON_UNIT_CODES_FETCH_ERROR = 'APPRAISAL/ECON_UNIT_CODES_FETCH_ERROR';

export const SET_SELECTED_ECON_UNIT_SEARCH_YEAR = 'APPRAISAL/SET_SELECTED_ECON_UNIT_SEARCH_YEAR';

export function setSelectedSearchYear(data) {
  return async dispatch => {
    dispatch({ type: SET_SELECTED_ECON_UNIT_SEARCH_YEAR, data: data });
  };
}

export const fetchEconUnitCodes = makeApiActionCreatorV3(
  api.fetchEconUnitCodes,
  ECON_UNIT_CODES_FETCH_START,
  ECON_UNIT_CODES_FETCH_SUCCESS,
  ECON_UNIT_CODES_FETCH_ERROR,
);

export const addEconUnitPropertyValuation = makeApiActionCreatorV3(
  api.addEconUnitPropertyValuation,
  ECONOMIC_UNIT_ADD_PROPERTY_VALUATION[START],
  ECONOMIC_UNIT_ADD_PROPERTY_VALUATION[SUCCESS],
  ECONOMIC_UNIT_ADD_PROPERTY_VALUATION[ERROR],
);

export const setEconUnitPropertyValuation = makeApiActionCreatorV3(
  api.setEconUnitPropertyValuation,
  ECONOMIC_UNIT_SET_PROPERTY_VALUATION[START],
  ECONOMIC_UNIT_SET_PROPERTY_VALUATION[SUCCESS],
  ECONOMIC_UNIT_SET_PROPERTY_VALUATION[ERROR],
);

export const searchEconomicStandalone = makeApiActionCreatorV3(
  api.searchEconomicStandalone,
  ECONOMIC_SEARCH_STANDALONE[START],
  ECONOMIC_SEARCH_STANDALONE[SUCCESS],
  ECONOMIC_SEARCH_STANDALONE[ERROR],
);

export const fetchIncomeRateTypes = makeApiActionCreatorV3(
  api.fetchIncomeRateTypes,
  FETCH_INCOME_RATE_TYPES[START],
  FETCH_INCOME_RATE_TYPES[SUCCESS],
  FETCH_INCOME_RATE_TYPES[ERROR],
);

export const fetchCodeFile = makeApiActionCreatorV3(
  api.fetchCodeFile,
  FETCH_CODE_FILE[START],
  FETCH_CODE_FILE[SUCCESS],
  FETCH_CODE_FILE[ERROR],
);

export const fetchIncomeCalculationRule = makeApiActionCreatorV3(
  api.fetchIncomeCalculationRule,
  FETCH_INCOME_CALCULATION_RULE[START],
  FETCH_INCOME_CALCULATION_RULE[SUCCESS],
  FETCH_INCOME_CALCULATION_RULE[ERROR],
);

export const fetchExpenseCalculationRule = makeApiActionCreatorV3(
  api.fetchExpenseCalculationRule,
  FETCH_EXPENSE_CALCULATION_RULE[START],
  FETCH_EXPENSE_CALCULATION_RULE[SUCCESS],
  FETCH_EXPENSE_CALCULATION_RULE[ERROR],
);

export const fetchLeasingConcessionsCalculationRule = makeApiActionCreatorV3(
  api.fetchLeasingConcessionsCalculationRule,
  FETCH_LEASING_CONCESSIONS_CALCULATION_RULE[START],
  FETCH_LEASING_CONCESSIONS_CALCULATION_RULE[SUCCESS],
  FETCH_LEASING_CONCESSIONS_CALCULATION_RULE[ERROR],
);

export const fetchReimbursedExpenseCalculationRule = makeApiActionCreatorV3(
  api.fetchReimbursedExpenseCalculationRule,
  FETCH_REIMBURSED_EXPENSE_CALCULATION_RULE[START],
  FETCH_REIMBURSED_EXPENSE_CALCULATION_RULE[SUCCESS],
  FETCH_REIMBURSED_EXPENSE_CALCULATION_RULE[ERROR],
);

export const searchEconomicUnits = makeApiActionCreatorV3(
  api.searchEconomicUnits,
  ECONOMIC_UNITS_SEARCH[START],
  ECONOMIC_UNITS_SEARCH[SUCCESS],
  ECONOMIC_UNITS_SEARCH[ERROR],
);

export const fetchEconomicUnit = makeApiActionCreatorV3(
  api.fetchEconomicUnit,
  ECONOMIC_UNIT_FETCH[START],
  ECONOMIC_UNIT_FETCH[SUCCESS],
  ECONOMIC_UNIT_FETCH[ERROR],
);

export const fetchSearchConfigs = makeApiActionCreatorV3(
  api.fetchSearchConfigs,
  ECONOMIC_UNITS_SEARCH_CONFIG[START],
  ECONOMIC_UNITS_SEARCH_CONFIG[SUCCESS],
  ECONOMIC_UNITS_SEARCH_CONFIG[ERROR],
);

export const createEconomicUnit = makeApiActionCreatorV3(
  api.createEconomicUnit,
  ECONOMIC_UNITS_CREATE[START],
  ECONOMIC_UNITS_CREATE[SUCCESS],
  ECONOMIC_UNITS_CREATE[ERROR],
);

export const updateEconomicUnit = makeApiActionCreatorV3(
  api.updateEconomicUnit,
  ECONOMIC_UNITS_UPDATE[START],
  ECONOMIC_UNITS_UPDATE[SUCCESS],
  ECONOMIC_UNITS_UPDATE[ERROR],
);

export const updateEconomicUnitDataInputs = makeApiActionCreatorV3(
  api.updateEconomicUnitDataInputs,
  ECONOMIC_UNITS_UPDATE_DATA_INPUTS[START],
  ECONOMIC_UNITS_UPDATE_DATA_INPUTS[SUCCESS],
  ECONOMIC_UNITS_UPDATE_DATA_INPUTS[ERROR],
);

export const createEconomicUnitProperty = makeApiActionCreatorV3(
  api.createEconomicUnitProperty,
  ECONOMIC_UNIT_PROPERTY_INSERT[START],
  ECONOMIC_UNIT_PROPERTY_INSERT[SUCCESS],
  ECONOMIC_UNIT_PROPERTY_INSERT[ERROR],
);

export const fetchEconomicUnitProperties = makeApiActionCreatorV3(
  api.fetchEconomicUnitProperties,
  ECONOMIC_UNIT_PROPERTY_FETCH[START],
  ECONOMIC_UNIT_PROPERTY_FETCH[SUCCESS],
  ECONOMIC_UNIT_PROPERTY_FETCH[ERROR],
);

export const deleteEconomicUnitProperties = makeApiActionCreatorV3(
  api.deleteEconomicUnitProperties,
  ECONOMIC_UNIT_PROPERTY_DELETE[START],
  ECONOMIC_UNIT_PROPERTY_DELETE[SUCCESS],
  ECONOMIC_UNIT_PROPERTY_DELETE[ERROR],
);

export const insertEconomicUnitPropertyUse = makeApiActionCreatorV3(
  api.insertEconomicUnitPropertyUse,
  ECONOMIC_UNIT_PROPERTY_USE_INSERT[START],
  ECONOMIC_UNIT_PROPERTY_USE_INSERT[SUCCESS],
  ECONOMIC_UNIT_PROPERTY_USE_INSERT[ERROR],
);

export const fetchEconomicUnitPropertyUses = makeApiActionCreatorV3(
  api.fetchEconomicUnitPropertyUses,
  ECONOMIC_UNIT_PROPERTY_USES_FETCH[START],
  ECONOMIC_UNIT_PROPERTY_USES_FETCH[SUCCESS],
  ECONOMIC_UNIT_PROPERTY_USES_FETCH[ERROR],
);

export const fetchEconomicUnitRentRolls = makeApiActionCreatorV3(
  api.fetchEconomicUnitRentRolls,
  ECONOMIC_UNIT_RENT_ROLLS_FETCH[START],
  ECONOMIC_UNIT_RENT_ROLLS_FETCH[SUCCESS],
  ECONOMIC_UNIT_RENT_ROLLS_FETCH[ERROR],
);

export const updateEconomicUnitPropertyUse = makeApiActionCreatorV3(
  api.updateEconomicUnitPropertyUse,
  ECONOMIC_UNIT_PROPERTY_USE_UPDATE[START],
  ECONOMIC_UNIT_PROPERTY_USE_UPDATE[SUCCESS],
  ECONOMIC_UNIT_PROPERTY_USE_UPDATE[ERROR],
);

export const refreshEconomicUnitLand = makeApiActionCreatorV3(
  api.refreshEconomicUnitLand,
  ECONOMIC_UNIT_REFRESH_LAND[START],
  ECONOMIC_UNIT_REFRESH_LAND[SUCCESS],
  ECONOMIC_UNIT_REFRESH_LAND[ERROR],
);

export const refreshEconomicUnitPropertyUseImprovement = makeApiActionCreatorV3(
  api.refreshEconomicUnitPropertyUseImprovement,
  ECONOMIC_UNIT_PROPERTY_USE_REFRESH_IMPROVEMENT[START],
  ECONOMIC_UNIT_PROPERTY_USE_REFRESH_IMPROVEMENT[SUCCESS],
  ECONOMIC_UNIT_PROPERTY_USE_REFRESH_IMPROVEMENT[ERROR],
);

export const deleteEconomicUnitPropertyUse = makeApiActionCreatorV3(
  api.deleteEconomicUnitPropertyUse,
  ECONOMIC_UNIT_PROPERTY_USE_DELETE[START],
  ECONOMIC_UNIT_PROPERTY_USE_DELETE[SUCCESS],
  ECONOMIC_UNIT_PROPERTY_USE_DELETE[ERROR],
);
export const ECONOMIC_UNITS_SEARCH_PARAMS_FETCH = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNITS_SEARCH_PARAMS_FETCH',
);

export const fetchEconomicUnitSearchParams = makeApiActionCreatorV3(
  api.fetchEconomicUnitSearchParams,
  ECONOMIC_UNITS_SEARCH_PARAMS_FETCH[START],
  ECONOMIC_UNITS_SEARCH_PARAMS_FETCH[SUCCESS],
  ECONOMIC_UNITS_SEARCH_PARAMS_FETCH[ERROR],
);

export const ECONOMIC_UNITS_SEARCH_PARAM_INSERT = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNITS_SEARCH_PARAM_INSERT',
);

export const insertEconomicUnitSearchParam = makeApiActionCreatorV3(
  api.insertEconomicUnitSearchParam,
  ECONOMIC_UNITS_SEARCH_PARAM_INSERT[START],
  ECONOMIC_UNITS_SEARCH_PARAM_INSERT[SUCCESS],
  ECONOMIC_UNITS_SEARCH_PARAM_INSERT[ERROR],
);

export const ECONOMIC_UNITS_SEARCH_PARAM_UPDATE = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNITS_SEARCH_PARAM_UPDATE',
);

export const updateEconomicUnitSearchParam = makeApiActionCreatorV3(
  api.updateEconomicUnitSearchParam,
  ECONOMIC_UNITS_SEARCH_PARAM_UPDATE[START],
  ECONOMIC_UNITS_SEARCH_PARAM_UPDATE[SUCCESS],
  ECONOMIC_UNITS_SEARCH_PARAM_UPDATE[ERROR],
);

export const ECONOMIC_UNITS_SEARCH_PARAM_DELETE = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNITS_SEARCH_PARAM_DELETE',
);

export const deleteEconomicUnitSearchParam = makeApiActionCreatorV3(
  api.deleteEconomicUnitSearchParam,
  ECONOMIC_UNITS_SEARCH_PARAM_DELETE[START],
  ECONOMIC_UNITS_SEARCH_PARAM_DELETE[SUCCESS],
  ECONOMIC_UNITS_SEARCH_PARAM_DELETE[ERROR],
);

export const ECONOMIC_UNITS_SEARCH_PARAM_DUPLICATE = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNITS_SEARCH_PARAM_DUPLICATE',
);

export const duplicateEconomicUnitSearchParam = makeApiActionCreatorV3(
  api.duplicateEconomicUnitSearchParam,
  ECONOMIC_UNITS_SEARCH_PARAM_DUPLICATE[START],
  ECONOMIC_UNITS_SEARCH_PARAM_DUPLICATE[SUCCESS],
  ECONOMIC_UNITS_SEARCH_PARAM_DUPLICATE[ERROR],
);

export const ECONOMIC_UNITS_SEARCH_PARAM_RESET =
  'APPRAISAL/ECONOMIC_UNITS_SEARCH_PARAM_RESET';

export const resetEconomicUnitsSearchParam = () => ({
  type: ECONOMIC_UNITS_SEARCH_PARAM_RESET,
});

export const ECONOMIC_UNITS_SEARCH_PARAM_SET =
  'APPRAISAL/ECONOMIC_UNITS_SEARCH_PARAM_SET';

export const setEconomicUnitsSearchParam = searchParamID => ({
  type: ECONOMIC_UNITS_SEARCH_PARAM_SET,
  searchParamID,
});

export const ECONOMIC_UNITS_SEARCH_CONFIG_FETCH = createRequestTypes(
  'APPRAISAL/ECONOMIC_UNITS_SEARCH_CONFIG_FETCH',
);

export const fetchEconomicUnitSearchConfig = makeApiActionCreatorV3(
  api.fetchEconomicUnitSearchConfig,
  ECONOMIC_UNITS_SEARCH_CONFIG_FETCH[START],
  ECONOMIC_UNITS_SEARCH_CONFIG_FETCH[SUCCESS],
  ECONOMIC_UNITS_SEARCH_CONFIG_FETCH[ERROR],
);

export const CHANGE_PAGE = `APPRAISAL/CHANGE_PAGE`;
export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `APPRAISAL/CHANGE_ROWS_PER_PAGE`;
export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const FETCH_ECONOMIC_UNIT_EVENTS = createRequestTypes(
  'APPRAISAL/FETCH_ECONOMIC_UNIT_EVENTS',
);

export const fetchEconomicUnitEvents = makeApiActionCreatorV3(
  api.fetchEconomicUnitEvents,
  FETCH_ECONOMIC_UNIT_EVENTS[START],
  FETCH_ECONOMIC_UNIT_EVENTS[SUCCESS],
  FETCH_ECONOMIC_UNIT_EVENTS[ERROR],
);

export const UPDATE_ECONOMIC_UNIT_EVENT_SEARCH_VALUE =
  'APPRAISAL/UPDATE_ECONOMIC_UNIT_EVENT_SEARCH_VALUE';

export function updateEventSearchValue(data) {
  return async dispatch => {
    dispatch({ type: UPDATE_ECONOMIC_UNIT_EVENT_SEARCH_VALUE, payload: data });
  };
}

export const FETCH_ECONOMIC_UNIT_FORM_OPTIONS_EVENTS = createRequestTypes(
  'APPRAISAL/FETCH_ECONOMIC_UNIT_FORM_OPTIONS_EVENTS',
);

export const fetchEconomicUnitFormOptions = makeApiActionCreatorV3(
  api.fetchEconomicUnitFormOptions,
  FETCH_ECONOMIC_UNIT_FORM_OPTIONS_EVENTS[START],
  FETCH_ECONOMIC_UNIT_FORM_OPTIONS_EVENTS[SUCCESS],
  FETCH_ECONOMIC_UNIT_FORM_OPTIONS_EVENTS[ERROR],
);

export const fetchEconomicUnitIncomeValuations = makeApiActionCreatorV3(
  api.fetchEconomicUnitIncomeValuations,
  ECONOMIC_UNIT_INCOME_VALUATIONS_FETCH[START],
  ECONOMIC_UNIT_INCOME_VALUATIONS_FETCH[SUCCESS],
  ECONOMIC_UNIT_INCOME_VALUATIONS_FETCH[ERROR],
);

export const fetchValidApproaches = makeApiActionCreatorV3(
  api.fetchValidApproaches,
  VALID_APPROACHES_FETCH[START],
  VALID_APPROACHES_FETCH[SUCCESS],
  VALID_APPROACHES_FETCH[ERROR],
);

export const createEconomicUnitIncomeValuation = makeApiActionCreatorV3(
  api.createEconomicUnitIncomeValuation,
  ECONOMIC_UNIT_INCOME_VALUATION_CREATE[START],
  ECONOMIC_UNIT_INCOME_VALUATION_CREATE[SUCCESS],
  ECONOMIC_UNIT_INCOME_VALUATION_CREATE[ERROR],
);

export const fetchIncomeDirectCap = makeApiActionCreatorV3(
  api.fetchIncomeDirectCap,
  INCOME_DIRECT_CAP_FETCH[START],
  INCOME_DIRECT_CAP_FETCH[SUCCESS],
  INCOME_DIRECT_CAP_FETCH[ERROR],
);

export const updateIncomeDirectCap = makeApiActionCreatorV3(
  api.updateIncomeDirectCap,
  INCOME_DIRECT_CAP_UPDATE[START],
  INCOME_DIRECT_CAP_UPDATE[SUCCESS],
  INCOME_DIRECT_CAP_UPDATE[ERROR],
);

export const fetchIncomeDirectCapActuals = makeApiActionCreatorV3(
  api.fetchIncomeDirectCapActuals,
  INCOME_DIRECT_CAP_ACTUALS_FETCH[START],
  INCOME_DIRECT_CAP_ACTUALS_FETCH[SUCCESS],
  INCOME_DIRECT_CAP_ACTUALS_FETCH[ERROR],
);

export const updateIncomeDirectCapActuals = makeApiActionCreatorV3(
  api.updateIncomeDirectCapActuals,
  INCOME_DIRECT_CAP_ACTUALS_UPDATE[START],
  INCOME_DIRECT_CAP_ACTUALS_UPDATE[SUCCESS],
  INCOME_DIRECT_CAP_ACTUALS_UPDATE[ERROR],
);

export const fetchIncomeDirectActualsPropertyUses = makeApiActionCreatorV3(
  api.fetchIncomeDirectActualsPropertyUses,
  INCOME_DIRECT_ACTUALS_PROPERTY_USES_FETCH[START],
  INCOME_DIRECT_ACTUALS_PROPERTY_USES_FETCH[SUCCESS],
  INCOME_DIRECT_ACTUALS_PROPERTY_USES_FETCH[ERROR],
);

export const fetchIncomeDirectActualsExpenses = makeApiActionCreatorV3(
  api.fetchIncomeDirectActualsExpenses,
  INCOME_DIRECT_ACTUALS_EXPENSES_FETCH[START],
  INCOME_DIRECT_ACTUALS_EXPENSES_FETCH[SUCCESS],
  INCOME_DIRECT_ACTUALS_EXPENSES_FETCH[ERROR],
);

export const fetchIncomeDirectActualsAddlIncome = makeApiActionCreatorV3(
  api.fetchIncomeDirectActualsAddlIncome,
  INCOME_DIRECT_ACTUALS_ADDL_INCOME_FETCH[START],
  INCOME_DIRECT_ACTUALS_ADDL_INCOME_FETCH[SUCCESS],
  INCOME_DIRECT_ACTUALS_ADDL_INCOME_FETCH[ERROR],
);

export const fetchIncomeDirectActualsAddlIncomeEGI = makeApiActionCreatorV3(
  api.fetchIncomeDirectActualsAddlIncomeEGI,
  INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI_FETCH[START],
  INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI_FETCH[SUCCESS],
  INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI_FETCH[ERROR],
);
export const FETCH_ECONOMIC_UNIT_NOTES = createRequestTypes(
  'APPRAISAL/FETCH_ECONOMIC_UNIT_NOTES',
);

export const fetchEconomicUnitNotes = makeApiActionCreatorV3(
  api.fetchEconomicUnitNotes,
  FETCH_ECONOMIC_UNIT_NOTES[START],
  FETCH_ECONOMIC_UNIT_NOTES[SUCCESS],
  FETCH_ECONOMIC_UNIT_NOTES[ERROR],
);

export const ADD_ECONOMIC_UNIT_NOTE = createRequestTypes(
  'APPRAISAL/ADD_ECONOMIC_UNIT_NOTE',
);

export const addEconomicUnitNote = makeApiActionCreatorV3(
  api.addEconomicUnitNote,
  ADD_ECONOMIC_UNIT_NOTE[START],
  ADD_ECONOMIC_UNIT_NOTE[SUCCESS],
  ADD_ECONOMIC_UNIT_NOTE[ERROR],
);

export const DELETE_ECONOMIC_UNIT_NOTE = createRequestTypes(
  'APPRAISAL/DELETE_ECONOMIC_UNIT_NOTE',
);

export const deleteEconomicUnitNote = makeApiActionCreatorV3(
  api.deleteEconomicUnitNote,
  DELETE_ECONOMIC_UNIT_NOTE[START],
  DELETE_ECONOMIC_UNIT_NOTE[SUCCESS],
  DELETE_ECONOMIC_UNIT_NOTE[ERROR],
);

export const UPDATE_ECONOMIC_UNIT_NOTE = createRequestTypes(
  'APPRAISAL/UPDATE_ECONOMIC_UNIT_NOTE',
);

export const updateEconomicUnitNote = makeApiActionCreatorV3(
  api.updateEconomicUnitNote,
  UPDATE_ECONOMIC_UNIT_NOTE[START],
  UPDATE_ECONOMIC_UNIT_NOTE[SUCCESS],
  UPDATE_ECONOMIC_UNIT_NOTE[ERROR],
);

export const UPDATE_ECONOMIC_UNIT_NOTE_TAGS = createRequestTypes(
  'APPRAISAL/UPDATE_ECONOMIC_UNIT_NOTE_TAGS',
);

export const updateEconomicUnitNoteTags = makeApiActionCreatorV3(
  api.updateEconomicUnitNoteTags,
  UPDATE_ECONOMIC_UNIT_NOTE_TAGS[START],
  UPDATE_ECONOMIC_UNIT_NOTE_TAGS[SUCCESS],
  UPDATE_ECONOMIC_UNIT_NOTE_TAGS[ERROR],
);

export const INSERT_ECONOMIC_UNIT_FILE = createRequestTypes(
  `APPRAISAL/INSERT_ECONOMIC_UNIT_FILE`,
);

export const insertEconomicUnitFile = makeApiActionCreatorV3(
  api.insertEconomicUnitFile,
  INSERT_ECONOMIC_UNIT_FILE[START],
  INSERT_ECONOMIC_UNIT_FILE[SUCCESS],
  INSERT_ECONOMIC_UNIT_FILE[ERROR],
);

export const DELETE_ECONOMIC_UNIT_FILE = createRequestTypes(
  `APPRAISAL/DELETE_ECONOMIC_UNIT_FILE`,
);

export const deleteEconomicUnitFile = makeApiActionCreatorV3(
  api.deleteEconomicUnitFile,
  DELETE_ECONOMIC_UNIT_FILE[START],
  DELETE_ECONOMIC_UNIT_FILE[SUCCESS],
  DELETE_ECONOMIC_UNIT_FILE[ERROR],
);

export const DOWNLOAD_ECONOMIC_UNIT_FILE = createRequestTypes(
  `APPRAISAL/DOWNLOAD_ECONOMIC_UNIT_FILE`,
);

export const downloadEconomicUnitFile = makeApiActionCreatorV3(
  api.downloadEconomicUnitFile,
  DOWNLOAD_ECONOMIC_UNIT_FILE[START],
  DOWNLOAD_ECONOMIC_UNIT_FILE[SUCCESS],
  DOWNLOAD_ECONOMIC_UNIT_FILE[ERROR],
);

export const UPDATE_ECONOMIC_UNIT_FILE = createRequestTypes(
  `APPRAISAL/UPDATE_ECONOMIC_UNIT_FILE`,
);

export const updateEconomicUnitFile = makeApiActionCreatorV3(
  api.updateEconomicUnitFile,
  UPDATE_ECONOMIC_UNIT_FILE[START],
  UPDATE_ECONOMIC_UNIT_FILE[SUCCESS],
  UPDATE_ECONOMIC_UNIT_FILE[ERROR],
);

export const insertIncomeDirectActualsPropertyUse = makeApiActionCreatorV3(
  api.insertIncomeDirectActualsPropertyUse,
  INSERT_INCOME_DIRECT_ACTUALS_PROPERTY_USE[START],
  INSERT_INCOME_DIRECT_ACTUALS_PROPERTY_USE[SUCCESS],
  INSERT_INCOME_DIRECT_ACTUALS_PROPERTY_USE[ERROR],
);

export const deleteIncomeDirectActualsPropertyUse = makeApiActionCreatorV3(
  api.deleteIncomeDirectActualsPropertyUse,
  DELETE_INCOME_DIRECT_ACTUALS_PROPERTY_USE[START],
  DELETE_INCOME_DIRECT_ACTUALS_PROPERTY_USE[SUCCESS],
  DELETE_INCOME_DIRECT_ACTUALS_PROPERTY_USE[ERROR],
);

export const updateIncomeDirectActualsPropertyUse = makeApiActionCreatorV3(
  api.updateIncomeDirectActualsPropertyUse,
  UPDATE_INCOME_DIRECT_ACTUALS_PROPERTY_USE[START],
  UPDATE_INCOME_DIRECT_ACTUALS_PROPERTY_USE[SUCCESS],
  UPDATE_INCOME_DIRECT_ACTUALS_PROPERTY_USE[ERROR],
);

export const insertIncomeDirectActualsExpense = makeApiActionCreatorV3(
  api.insertIncomeDirectActualsExpense,
  INSERT_INCOME_DIRECT_ACTUALS_EXPENSE[START],
  INSERT_INCOME_DIRECT_ACTUALS_EXPENSE[SUCCESS],
  INSERT_INCOME_DIRECT_ACTUALS_EXPENSE[ERROR],
);

export const deleteIncomeDirectActualsExpense = makeApiActionCreatorV3(
  api.deleteIncomeDirectActualsExpense,
  DELETE_INCOME_DIRECT_ACTUALS_EXPENSE[START],
  DELETE_INCOME_DIRECT_ACTUALS_EXPENSE[SUCCESS],
  DELETE_INCOME_DIRECT_ACTUALS_EXPENSE[ERROR],
);

export const updateIncomeDirectActualsExpense = makeApiActionCreatorV3(
  api.updateIncomeDirectActualsExpense,
  UPDATE_INCOME_DIRECT_ACTUALS_EXPENSE[START],
  UPDATE_INCOME_DIRECT_ACTUALS_EXPENSE[SUCCESS],
  UPDATE_INCOME_DIRECT_ACTUALS_EXPENSE[ERROR],
);

export const insertIncomeDirectActualsAddlIncome = makeApiActionCreatorV3(
  api.insertIncomeDirectActualsAddlIncome,
  INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME[START],
  INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME[SUCCESS],
  INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME[ERROR],
);

export const updateIncomeDirectActualsAddlIncome = makeApiActionCreatorV3(
  api.updateIncomeDirectActualsAddlIncome,
  UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME[START],
  UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME[SUCCESS],
  UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME[ERROR],
);

export const deleteIncomeDirectActualsAddlIncome = makeApiActionCreatorV3(
  api.deleteIncomeDirectActualsAddlIncome,
  DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME[START],
  DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME[SUCCESS],
  DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME[ERROR],
);

export const insertIncomeDirectActualsAddlIncomeEGI = makeApiActionCreatorV3(
  api.insertIncomeDirectActualsAddlIncomeEGI,
  INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[START],
  INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[SUCCESS],
  INSERT_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[ERROR],
);

export const updateIncomeDirectActualsAddlIncomeEGI = makeApiActionCreatorV3(
  api.updateIncomeDirectActualsAddlIncomeEGI,
  UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[START],
  UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[SUCCESS],
  UPDATE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[ERROR],
);

export const deleteIncomeDirectActualsAddlIncomeEGI = makeApiActionCreatorV3(
  api.deleteIncomeDirectActualsAddlIncomeEGI,
  DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[START],
  DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[SUCCESS],
  DELETE_INCOME_DIRECT_ACTUALS_ADDL_INCOME_EGI[ERROR],
);

export const recalculateDirectCapActuals = makeApiActionCreatorV3(
  api.recalculateDirectCapActuals,
  RECALCULATE_DIRECT_CAP_ACTUALS[START],
  RECALCULATE_DIRECT_CAP_ACTUALS[SUCCESS],
  RECALCULATE_DIRECT_CAP_ACTUALS[ERROR],
);

export const recalculateEconomicUnit = makeApiActionCreatorV3(
  api.recalculateEconomicUnit,
  ECONOMIC_UNIT_RECALCULATE[START],
  ECONOMIC_UNIT_RECALCULATE[SUCCESS],
  ECONOMIC_UNIT_RECALCULATE[ERROR],
);

export const fetchRecalculatedValues = () => async (dispatch, getState) => {
  const state = getState();
  const {
    selectedEconomicUnitRecord: econId,
    selectedEconomicUnitYear: pYear,
    selectedEconomicUnitRollCorr: pRollCorr,
    selectedEconomicUnitVersion: pVersion,
  } = state.getIn(['app', 'appraisal', 'global']).toJS();
  const params = { pYear, econId, pVersion, pRollCorr };
  dispatch(fetchEconomicUnitIncomeValuations(params));
  dispatch(fetchEconomicUnitPropertyValuations(params));
  dispatch(fetchEconomicUnitReconcile(params));
  dispatch(fetchEconomicUnitAllocate(params));
  dispatch(fetchEconomicUnitDistribution(params));
};

export const deleteDirectCapActuals = makeApiActionCreatorV3(
  api.deleteDirectCapActuals,
  DELETE_DIRECT_CAP_ACTUALS[START],
  DELETE_DIRECT_CAP_ACTUALS[SUCCESS],
  DELETE_DIRECT_CAP_ACTUALS[ERROR],
);

export const deleteDirectCapModel = makeApiActionCreatorV3(
  api.deleteDirectCapModel,
  DELETE_DIRECT_CAP_MODEL[START],
  DELETE_DIRECT_CAP_MODEL[SUCCESS],
  DELETE_DIRECT_CAP_MODEL[ERROR],
);

export const fetchEconomicUnitPropertyValuations = makeApiActionCreatorV3(
  api.fetchEconomicUnitPropertyValuations,
  FETCH_ECONOMIC_UNIT_PROPERTY_VALUATIONS[START],
  FETCH_ECONOMIC_UNIT_PROPERTY_VALUATIONS[SUCCESS],
  FETCH_ECONOMIC_UNIT_PROPERTY_VALUATIONS[ERROR],
);

export const includeEconomicUnitPropertyValuation = makeApiActionCreatorV3(
  api.includeEconomicUnitPropertyValuation,
  INCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION[START],
  INCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION[SUCCESS],
  INCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION[ERROR],
);

export const excludeEconomicUnitPropertyValuation = makeApiActionCreatorV3(
  api.excludeEconomicUnitPropertyValuation,
  EXCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION[START],
  EXCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION[SUCCESS],
  EXCLUDE_ECONOMIC_UNIT_PROPERTY_VALUATION[ERROR],
);

export const fetchEconomicUnitReconcile = makeApiActionCreatorV3(
  api.fetchEconomicUnitReconcile,
  FETCH_ECONOMIC_UNIT_RECONCILE[START],
  FETCH_ECONOMIC_UNIT_RECONCILE[SUCCESS],
  FETCH_ECONOMIC_UNIT_RECONCILE[ERROR],
);

export const updateEconomicUnitReconcile = makeApiActionCreatorV3(
  api.updateEconomicUnitReconcile,
  UPDATE_ECONOMIC_UNIT_RECONCILE[START],
  UPDATE_ECONOMIC_UNIT_RECONCILE[SUCCESS],
  UPDATE_ECONOMIC_UNIT_RECONCILE[ERROR],
);

export const fetchEconomicUnitAllocate = makeApiActionCreatorV3(
  api.fetchEconomicUnitAllocate,
  FETCH_ECONOMIC_UNIT_ALLOCATE[START],
  FETCH_ECONOMIC_UNIT_ALLOCATE[SUCCESS],
  FETCH_ECONOMIC_UNIT_ALLOCATE[ERROR],
);

export const updateEconomicUnitAllocate = makeApiActionCreatorV3(
  api.updateEconomicUnitAllocate,
  UPDATE_ECONOMIC_UNIT_ALLOCATE[START],
  UPDATE_ECONOMIC_UNIT_ALLOCATE[SUCCESS],
  UPDATE_ECONOMIC_UNIT_ALLOCATE[ERROR],
);

export const fetchEconomicUnitDistribution = makeApiActionCreatorV3(
  api.fetchEconomicUnitDistribution,
  FETCH_ECONOMIC_UNIT_DISTRIBUTION[START],
  FETCH_ECONOMIC_UNIT_DISTRIBUTION[SUCCESS],
  FETCH_ECONOMIC_UNIT_DISTRIBUTION[ERROR],
);

export const updateEconomicUnitDistribution = makeApiActionCreatorV3(
  api.updateEconomicUnitDistribution,
  UPDATE_ECONOMIC_UNIT_DISTRIBUTION[START],
  UPDATE_ECONOMIC_UNIT_DISTRIBUTION[SUCCESS],
  UPDATE_ECONOMIC_UNIT_DISTRIBUTION[ERROR],
);

export const updateIncomeDirectActualsName = makeApiActionCreatorV3(
  api.updateIncomeDirectActualsName,
  UPDATE_INCOME_DIRECT_ACTUALS_NAME[START],
  UPDATE_INCOME_DIRECT_ACTUALS_NAME[SUCCESS],
  UPDATE_INCOME_DIRECT_ACTUALS_NAME[ERROR],
);

export const updateMarketAreaTaxRate = makeApiActionCreatorV3(
  api.updateMarketAreaTaxRate,
  UPDATE_MARKET_AREA_TAX_RATE[START],
  UPDATE_MARKET_AREA_TAX_RATE[SUCCESS],
  UPDATE_MARKET_AREA_TAX_RATE[ERROR],
);

export const updateMarketAreaTaxRateLoad = makeApiActionCreatorV3(
  api.updateMarketAreaTaxRate,
  UPDATE_MARKET_AREA_TAX_RATE_LOAD[START],
  UPDATE_MARKET_AREA_TAX_RATE_LOAD[SUCCESS],
  UPDATE_MARKET_AREA_TAX_RATE_LOAD[ERROR],
);

export const fetchPropUseRentRolls = makeApiActionCreatorV3(
  api.fetchPropUseRentRolls,
  FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLLS[START],
  FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLLS[SUCCESS],
  FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLLS[ERROR],
);

export const createPropUseRentRoll = makeApiActionCreatorV3(
  api.createPropUseRentRoll,
  CREATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[START],
  CREATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[SUCCESS],
  CREATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[ERROR],
);

export const updatePropUseRentRoll = makeApiActionCreatorV3(
  api.updatePropUseRentRoll,
  UPDATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[START],
  UPDATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[SUCCESS],
  UPDATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[ERROR],
);

export const deletePropUseRentRoll = makeApiActionCreatorV3(
  api.deletePropUseRentRoll,
  DELETE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[START],
  DELETE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[SUCCESS],
  DELETE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[ERROR],
);

export const deleteEconomicUnit = makeApiActionCreatorV3(
  api.deleteEconomicUnit,
  DELETE_ECONOMIC_UNIT[START],
  DELETE_ECONOMIC_UNIT[SUCCESS],
  DELETE_ECONOMIC_UNIT[ERROR],
);

export const fetchPropUseRentRollSummary = makeApiActionCreatorV3(
  api.fetchPropUseRentRollSummary,
  FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLL_SUMMARY[START],
  FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLL_SUMMARY[SUCCESS],
  FETCH_ECONOMIC_UNIT_PROPUSE_RENT_ROLL_SUMMARY[ERROR],
);

export const updatePropUseRentRollSummary = makeApiActionCreatorV3(
  api.updatePropUseRentRollSummary,
  UPDATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL_SUMMARY[START],
  UPDATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL_SUMMARY[SUCCESS],
  UPDATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL_SUMMARY[ERROR],
);

export const calculatePropUseRentRoll = makeApiActionCreatorV3(
  api.calculatePropUseRentRoll,
  CALCULATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[START],
  CALCULATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[SUCCESS],
  CALCULATE_ECONOMIC_UNIT_PROPUSE_RENT_ROLL[ERROR],
);

export const COPY_MODEL_TO_ACTUALS = createRequestTypes(
  'APPRAISAL/COPY_MODEL_TO_ACTUALS',
);

export const copyModelToActuals = makeApiActionCreatorV3(
  api.copyModelToActuals,
  COPY_MODEL_TO_ACTUALS[START],
  COPY_MODEL_TO_ACTUALS[SUCCESS],
  COPY_MODEL_TO_ACTUALS[ERROR],
);

export const FETCH_OVERRIDE_RENT_SUMMARY = createRequestTypes(
  'APPRAISAL/FETCH_OVERRIDE_RENTS_SUMMARY',
);

export const fetchOverrideRentSummary = makeApiActionCreatorV3(
  api.fetchOverrideRentSummary,
  FETCH_OVERRIDE_RENT_SUMMARY[START],
  FETCH_OVERRIDE_RENT_SUMMARY[SUCCESS],
  FETCH_OVERRIDE_RENT_SUMMARY[ERROR],
);

export const FETCH_OVERRIDE_RENT_RATE_TYPES = createRequestTypes(
  'APPRAISAL/FETCH_OVERRIDE_RENT_RATE_TYPES',
);

export const fetchOverrideRentRateTypes = makeApiActionCreatorV3(
  api.fetchOverrideRentRateTypes,
  FETCH_OVERRIDE_RENT_RATE_TYPES[START],
  FETCH_OVERRIDE_RENT_RATE_TYPES[SUCCESS],
  FETCH_OVERRIDE_RENT_RATE_TYPES[ERROR],
);

export const FETCH_OVERRIDE_RENTS = createRequestTypes(
  'APPRAISAL/FETCH_OVERRIDE_RENTS',
);

export const fetchOverrideRents = makeApiActionCreatorV3(
  api.fetchOverrideRents,
  FETCH_OVERRIDE_RENTS[START],
  FETCH_OVERRIDE_RENTS[SUCCESS],
  FETCH_OVERRIDE_RENTS[ERROR],
);

export const DUPLICATE_INCOME_DIRECT_CAP_ACTUAL = createRequestTypes(
  'APPRAISAL/DUPLICATE_INCOME_DIRECT_CAP_ACTUAL',
);

export const duplicateIncomeDirectCapActual = makeApiActionCreatorV3(
  api.duplicateIncomeDirectCapActual,
  DUPLICATE_INCOME_DIRECT_CAP_ACTUAL[START],
  DUPLICATE_INCOME_DIRECT_CAP_ACTUAL[SUCCESS],
  DUPLICATE_INCOME_DIRECT_CAP_ACTUAL[ERROR],
);

export const INSERT_OVERRIDE_RENT = createRequestTypes(
  'APPRAISAL/INSERT_OVERRIDE_RENT',
);

export const insertOverrideRent = makeApiActionCreatorV3(
  api.insertOverrideRent,
  INSERT_OVERRIDE_RENT[START],
  INSERT_OVERRIDE_RENT[SUCCESS],
  INSERT_OVERRIDE_RENT[ERROR],
);

export const DELETE_OVERRIDE_RENT = createRequestTypes(
  'APPRAISAL/DELETE_OVERRIDE_RENT',
);

export const deleteOverrideRent = makeApiActionCreatorV3(
  api.deleteOverrideRent,
  DELETE_OVERRIDE_RENT[START],
  DELETE_OVERRIDE_RENT[SUCCESS],
  DELETE_OVERRIDE_RENT[ERROR],
);

export const UPDATE_OVERRIDE_RENT = createRequestTypes(
  'APPRAISAL/UPDATE_OVERRIDE_RENT',
);

export const updateOverrideRent = makeApiActionCreatorV3(
  api.updateOverrideRent,
  UPDATE_OVERRIDE_RENT[START],
  UPDATE_OVERRIDE_RENT[SUCCESS],
  UPDATE_OVERRIDE_RENT[ERROR],
);

export const FETCH_ECO_REVISION_HISTORY = createRequestTypes(
  'APPRAISAL/FETCH_ECO_REVISION_HISTORY',
);

export const fetchEcoRevisionHistory = makeApiActionCreatorV3(
  api.fetchEcoRevisionHistory,
  FETCH_ECO_REVISION_HISTORY[START],
  FETCH_ECO_REVISION_HISTORY[SUCCESS],
  FETCH_ECO_REVISION_HISTORY[ERROR],
);